import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/transaction/sampling-requests'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        searchAllByRequestNo(context, { criteria, config, searchQuery, where = [], children = [] }) {
            const wheres = [
                { name: "isActive", type: "Boolean", operator: '=', value: true }
            ]
            if (searchQuery) {
                wheres.push({ name: "requestNo", type: 'String', operator: 'like', value: searchQuery })
            }
            criteria = lodash.merge({
                select: ['id', 'version', 'requestNo', 'refSamplingRequestType.*', 'refSamplingStatus.*'],
                page: 0,
                size: 20,
                sort: [{ name: "requestNo", type: "DESC" }],
                where: [...wheres, ...where],
                children: children
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    return list
                });
        },
        reportSamplingRequest(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/sampling-request`, data, { ...config, responseType: "blob" });
        }
    },
    mutations: {
        ...base.mutations
    },
}
